import { useTheme } from '@mui/material/styles'

export const useThemeColors = () => {
  const theme = useTheme()
  const { primary, secondary, success, warning, error, info, text, background, divider } = theme.palette

  return {
    primary: primary.main,
    secondary: secondary.main,
    success: success.main,
    warning: warning.main,
    error: error.main,
    info: info.main,
    text: {
      primary: text.primary,
      secondary: text.secondary,
    },
    background: {
      paper: background.paper,
      default: background.default,
    },
    divider: divider,
  }
}

// Predefined chart color arrays
export const useChartColors = () => {
  const colors = useThemeColors()

  return [
    colors.primary,
    colors.secondary,
    colors.success,
    colors.warning,
    colors.error,
    colors.info,
  ]
}